/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type QrCodeShow_lists$ref = any;
type QrCodeShow_qrCode$ref = any;
export type QrCodeShowQueryVariables = {|
  qrCodeId: string
|};
export type QrCodeShowQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: QrCodeShow_lists$ref
  |},
  +qrCode: ?{|
    +$fragmentRefs: QrCodeShow_qrCode$ref
  |},
|};
export type QrCodeShowQuery = {|
  variables: QrCodeShowQueryVariables,
  response: QrCodeShowQueryResponse,
|};
*/


/*
query QrCodeShowQuery(
  $qrCodeId: ID!
) {
  lists {
    ...QrCodeShow_lists
    id
  }
  qrCode(id: $qrCodeId) {
    ...QrCodeShow_qrCode
    id
  }
}

fragment QrCodeShow_lists on Lists {
  id
  qrCodes(first: 100) {
    edges {
      node {
        id
        createdAt
        link
        sign
      }
    }
  }
}

fragment QrCodeShow_qrCode on QrCode {
  id
  createdAt
  link
  sign
  qrCodeUrl
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "qrCodeId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "qrCodeId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sign",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QrCodeShowQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "QrCodeShow_lists"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "QrCode",
        "kind": "LinkedField",
        "name": "qrCode",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "QrCodeShow_qrCode"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QrCodeShowQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "QrCodeConnection",
            "kind": "LinkedField",
            "name": "qrCodes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QrCodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QrCode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "qrCodes(first:100)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "QrCode",
        "kind": "LinkedField",
        "name": "qrCode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "qrCodeUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "QrCodeShowQuery",
    "operationKind": "query",
    "text": "query QrCodeShowQuery(\n  $qrCodeId: ID!\n) {\n  lists {\n    ...QrCodeShow_lists\n    id\n  }\n  qrCode(id: $qrCodeId) {\n    ...QrCodeShow_qrCode\n    id\n  }\n}\n\nfragment QrCodeShow_lists on Lists {\n  id\n  qrCodes(first: 100) {\n    edges {\n      node {\n        id\n        createdAt\n        link\n        sign\n      }\n    }\n  }\n}\n\nfragment QrCodeShow_qrCode on QrCode {\n  id\n  createdAt\n  link\n  sign\n  qrCodeUrl\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4cf344513cf05cd5fc441efe2af607d6';

module.exports = node;
